import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';

import { HelpService } from '@open-portal-app/help/services/help.service';

import { COMMON_CONSTANTS } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class HelpResolver implements Resolve<boolean> {
  raptorFlows = COMMON_CONSTANTS.raptorFlows;

  constructor(
    private helpService: HelpService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const { queryParams } = route;

    if (this.raptorFlows.indexOf(queryParams.flow) > -1) {
      this.helpService.prePopulateSupportSteps(queryParams);
    }

    return;
  }
}
